import React from 'react';
import Compiler from './Compiler';
import { exampleStories } from '../data/exampleStories';

const UsageTypeDemo = () => {
  const story = exampleStories['usage-type-demo'];
  
  if (!story) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Demo Not Found</h1>
          <p className="text-slate-600">The usage type demo couldn't be loaded.</p>
        </div>
      </div>
    );
  }
  
  return (
    <Compiler 
      initialTwee={story.twee}
      pageTitle={story.title}
      isExample={true}
      exampleCategory={story.category}
      exampleDescription={story.description}
      initialLayout="leftRight"
    />
  );
};

export default UsageTypeDemo;
